module.exports = "export default __webpack_public_path__ + &quot;9afa38406c3a468e9eab76abee94726f.svg&quot;;"